/* eslint-disable no-console */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { fileManage } from './fileManage.js';
import { videoManage } from './videoManage.js';
import { pictureManage } from './pictureManage.js';
import { musicManage } from './musicManage.js';

var $ = jquery;

	i18n.set({
		messages: {
			'zh-CN': {
				tinymceComponent: {
					mediaMenu: '媒体',
					networkError: '网络错误：{status}'
				}
			},
			'en-US': {
				tinymceComponent: {
					mediaMenu: 'Media',
					networkError: 'Network error: {status}'
				}
			}
		}
	});
	var tt = function(key, fallback, params){
		return i18n.translate('tinymceComponent.' + key, params, { default: fallback });
	};

    var modPath = '/static/common/layui/components/tinymce'

    var setter = (window.layui && window.layui.setter) || {}

    var response = setter.response || {}

    var settings = {
        base_url: modPath
        , images_upload_url: ''//图片上传接口
        , language: 'zh_CN'
        , response: {
            statusName: response.statusName || 'code'//返回状态字段
            , msgName: response.msgName || 'msg'//返回消息字段
            , dataName: response.dataName || 'data'//返回的数据
            , statusCode: response.statusCode || {
                ok: 0//数据正常
            }
        }
        , success: function (res, succFun, failFun) {//上传完成回调
            if (res.code==0) {
                console.log(res);
                succFun(res.data.path);
            } else {
                failFun(res.msg);
            }
        }
    };

    var t = {};
    var tinymceScriptLoaded = false;

    t.render = function (option) {

        var admin = (window.layui && window.layui.admin) || {}

        option.base_url = option.base_url ? option.base_url : settings.base_url

        option.language = option.language ? option.language : ((i18n.config && i18n.config.locale) === 'en-US' ? 'en_US' : settings.language)

        option.license_key = 'gpl'

        option.selector = option.elem

        option.quickbars_selection_toolbar = option.quickbars_selection_toolbar ? option.quickbars_selection_toolbar : 'cut copy | bold italic underline strikethrough '

        option.plugins = option.plugins ? option.plugins : 'preview searchreplace autolink directionality visualblocks visualchars fullscreen g_image g_video g_music g_file link code codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help emoticons autosave autoresize',

        option.toolbar = option.toolbar ? option.toolbar : 'code undo redo styles restoredraft cut copy paste pastetext forecolor backcolor bold italic underline strikethrough link anchor alignleft aligncenter alignright alignjustify outdent indent styles fontfamily fontsize bullist numlist blockquote subscript superscript removeformat table g_image g_video g_music g_file charmap emoticons hr pagebreak insertdatetime preview fullscreen';
       
        option.toolbar_mode='wrap';

        option.resize = true;
        option.autosave_ask_before_unload=false;
		option.height= option.height ? option.height :650;
        option.min_height= option.min_height ? option.min_height :650;
        option.elementpath = false;
        option.branding = false;
		option.relative_urls=false;
		option.content_style=option.content_style?option.content_style:'';
        option.content_css=option.content_css?option.content_css:'/static/common/layui/css/layui.css';
		option.font_family_formats=option.font_family_formats ? option.font_family_formats :'微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;',

		option.font_size_formats=option.font_size_formats ? option.font_size_formats :'12px 14px 16px 18px 24px 36px 48px 56px 72px',
        option.contextmenu_never_use_native = true;

        option.menubar = option.menubar ? option.menubar : 'file edit insert format table media tools help';

        option.promotion = false;
        option.menu =  {
            media: { title: tt('mediaMenu', '媒体'), items: 'g_image g_video g_music g_file' }
        };

        option.images_upload_url = option.uploadImage.pictureUploadUrl ? option.uploadImage.pictureUploadUrl : settings.images_upload_url;

		option.file_picker_callback=function (callback, value, meta) {
			if (meta.filetype === 'file') {
			  var fileManageInstance = new fileManage();
				fileManageInstance.init({
					elem: option.elem.replace('#',''),
					size: option.uploadFiles.size,
					exts: option.uploadFiles.exts,
					acceptMime: option.uploadFiles.acceptMime,
					multiple: true,
					fileUploadUrl:option.uploadFiles.fileUploadUrl,
					fileUrl:option.uploadFiles.fileUrl,
					fileDelUrl:option.uploadFiles.fileDelUrl,
					editFileNameUrl:option.uploadFiles.editFileNameUrl,
					fileMoveUrl:option.uploadFiles.fileMoveUrl,
					fileCategoryUrl:option.uploadFiles.fileCategoryUrl,
					fileCategoryUpdateUrl:option.uploadFiles.fileCategoryUpdateUrl,
					fileCategoryDelUrl:option.uploadFiles.fileCategoryDelUrl,
					fileCategory:option.uploadFiles.fileCategory,
					callback: function (a, b, c) {
						if (a == 'select') {
							callback(c.path, { text: c.name});
						}
					}
				});
				fileManageInstance.render();
			}
			if (meta.filetype === 'audio') {
				var musicManageInstance = new musicManage();
				musicManageInstance.init({
					elem: option.elem.replace('#',''),
					size: option.uploadAudio.size,
					exts: option.uploadAudio.exts,
					acceptMime: option.uploadAudio.acceptMime,
					multiple: true,
					musicUploadUrl:option.uploadAudio.musicUploadUrl,
					musicUrl:option.uploadAudio.musicUrl,
					musicDelUrl:option.uploadAudio.musicDelUrl,
					editMusicNameUrl:option.uploadAudio.editMusicNameUrl,
					musicMoveUrl:option.uploadAudio.musicMoveUrl,
					musicCategoryUrl:option.uploadAudio.musicCategoryUrl,
					musicCategoryUpdateUrl:option.uploadAudio.musicCategoryUpdateUrl,
					musicCategoryDelUrl:option.uploadAudio.musicCategoryDelUrl,
					musicCategory:option.uploadAudio.musicCategory,
					callback: function (a, b, c) {
						if (a == 'select') {
							callback(c.path, { text: c.name});
						}
					}
				});
				musicManageInstance.render();
			}
			if (meta.filetype === 'image') {
				var pictureManageInstance = new pictureManage();
                    pictureManageInstance.init({
                        elem: option.elem.replace('#',''),
						size: option.uploadImage.size,
						exts: option.uploadImage.exts,
						acceptMime: option.uploadImage.acceptMime,
						multiple: false,
						pictureUploadUrl:option.uploadImage.pictureUploadUrl,
						pictureUrl:option.uploadImage.pictureUrl,
						pictureDelUrl:option.uploadImage.pictureDelUrl,
						editPictureNameUrl:option.uploadImage.editPictureNameUrl,
						pictureMoveUrl:option.uploadImage.pictureMoveUrl,
						pictureCategoryUrl:option.uploadImage.pictureCategoryUrl,
						pictureCategoryUpdateUrl:option.uploadImage.pictureCategoryUpdateUrl,
						pictureCategoryDelUrl:option.uploadImage.pictureCategoryDelUrl,
						pictureCategory:option.uploadImage.pictureCategory,
						callback: function (a, b, c, d) {
                            if (a == 'select') {
                               callback(c, { text: d.name});
							   pictureManageInstance.close();
                            }
                        }
                    })

                    pictureManageInstance.render();
			}
			if (meta.filetype === 'media') {
				var videoManageInstance = new videoManage();
                    videoManageInstance.init({
                        elem: option.elem.replace('#',''),
						size: option.uploadVideo.size,
						exts: option.uploadVideo.exts,
						acceptMime: option.uploadVideo.acceptMime,
						multiple: true,
						videoUploadUrl:option.uploadVideo.videoUploadUrl,
						videoUrl:option.uploadVideo.videoUrl,
						videoDelUrl:option.uploadVideo.videoDelUrl,
						editVideoNameUrl:option.uploadVideo.editVideoNameUrl,
						videoMoveUrl:option.uploadVideo.videoMoveUrl,
						videoCategoryUrl:option.uploadVideo.videoCategoryUrl,
						videoCategoryUpdateUrl:option.uploadVideo.videoCategoryUpdateUrl,
						videoCategoryDelUrl:option.uploadVideo.videoCategoryDelUrl,
						videoCategory:option.uploadVideo.videoCategory,
						callback: function (a, b, c) {
                            if (a == 'select') {
                                callback(c.path);
                            }
                        }
                    });
                    videoManageInstance.render();
			}
		};
					
        option.images_upload_handler = function (blobInfo, succFun, failFun) {

            var formData = new FormData();

            formData.append('target', 'edit');

            formData.append('file', blobInfo.blob());

            var ajaxOpt = {

                url: option.images_upload_url,

                dataType: 'json',

                type: 'POST',

                data: formData,

                processData: false,

                contentType: false,

                success: function (res) {

                    settings.success(res, succFun, failFun)

                },
                error: function (res) {

                    failFun(tt('networkError', '网络错误：{status}', {status: res.status}));

                }
            };

            if (typeof admin.req == 'function') {

                admin.req(ajaxOpt);

            } else {

                $.ajax(ajaxOpt);

            }
        }
		
        option.menu = option.menu ? option.menu : true;
        if (!window.tinymce && !tinymceScriptLoaded) {
            $.ajax({
                url: option.base_url + '/tinymce.min.js',
                dataType: 'script',
                cache: true,
                async: false,
            });
            tinymceScriptLoaded = !!window.tinymce;
        } else if (window.tinymce) {
            tinymceScriptLoaded = true;
        }
        option.selector=option.elem;
        var tinymce = window.tinymce;
        tinymce.init(option);
        tinymce.settings=option;

        t.tinymce = tinymce;

        return tinymce.activeEditor;
    };
export { t as tinymce };
